import { server_ip } from "../config"
export async function fetchRooms(filter ={}, options ={}){
    try{
        const res = await fetch(`${server_ip}/api/rooms/find`,{
            method:'POST',
            body: JSON.stringify({filter, options})

        })
        const json = await res.json()
        return json
    }catch(err){
        return {errno:1, message:'Unexpected Errpr'}
    }
}